import { PayloadAction } from '@reduxjs/toolkit';
import {
  TDocumentPreviewPersonalDataResponse,
  TPersonalDataApplicationsStore,
} from '~/store/processing-personal/types.ts';

export const documentPreviewFulfilled = (
  state: TPersonalDataApplicationsStore,
  action: PayloadAction<TDocumentPreviewPersonalDataResponse>
) => {
  state.loading = false;
  state.fileURL = action.payload.fileURL;
  state.appId = action.payload.appId;
  state.docId = action.payload.docId;
  state.error = null;
};

export const documentPreviewPending = (state: TPersonalDataApplicationsStore) => {
  state.loading = true;
  state.error = null;
};
